import React,{useState,useEffect,useRef}from 'react'
import { Modal,Form,Input, App, DatePicker, InputNumber } from 'antd';
import { useQiyeyhzhUpdateSaveMutation, useQiyeyhzhUpdateQuery } from '../../store/DianShangYeWuApi';  
import dayjs from 'dayjs';
function AccountEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        'qyyhzh_qy_id': props.qy_id,
        'qyyhzh_qy_name': props.qy_name,
        'qyyhzh_name': props.qyyhzh_name,
        'qyyhzh_full_name': props.qyyhzh_full_name,
        'qyyhzh_code': props.qyyhzh_code,
        'qyyhzh_firm': props.qyyhzh_firm,
        'qyyhzh_uid': props.yh_id,
        'qyyhzh_uname': props.yh_name,
        'qyyhzh_content': props.qyyhzh_content,
        'qyyhzh_id': props.qyyhzh_id,
        'qyyhzh_update_uname':props.yh_name
    }); 
    const {data,isSuccess} = useQiyeyhzhUpdateQuery({qyyhzh_id:props.qyyhzh_id},{refetchOnMountOrArgChange:1,skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                setInfo(prevState=>({...prevState,
                    qyyhzh_name:data.Result.qyyhzh_name,
                    qyyhzh_full_name:data.Result.qyyhzh_full_name,
                    qyyhzh_code:data.Result.qyyhzh_code,
                    qyyhzh_firm:data.Result.qyyhzh_firm,
                    qyyhzh_content:data.Result.qyyhzh_content,
                    qyyhzh_qc_amount:data.Result.qyyhzh_qc_amount,
                    qyyhzh_qc_date:data.Result.qyyhzh_qc_date,
                }))
                if(editForm.current){   
                    editForm.current.setFieldsValue({
                        qyyhzh_name:data.Result.qyyhzh_name,
                        qyyhzh_full_name:data.Result.qyyhzh_full_name,
                        qyyhzh_code:data.Result.qyyhzh_code,
                        qyyhzh_firm:data.Result.qyyhzh_firm,
                        qyyhzh_content:data.Result.qyyhzh_content,
                        qyyhzh_qc_amount:data.Result.qyyhzh_qc_amount,
                        qyyhzh_qc_date:dayjs(data.Result.qyyhzh_qc_date),
                    })   
                }
            }
        }
    },[data,isSuccess,props])
    const [qyyhzhEdit] = useQiyeyhzhUpdateSaveMutation()    
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.qyyhzh_name}</a>
            <Modal
                width={800}                      
                open={open}
                title='修改银行账户'
                okText="保存"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {                    
                    form
                        .validateFields()
                        .then((values) => {
                            qyyhzhEdit({
                                'qyyhzh_qy_id': props.qy_id,
                                'qyyhzh_qy_name': props.qy_name,
                                'qyyhzh_name': info.qyyhzh_name,
                                'qyyhzh_full_name': props.qyyhzh_full_name,
                                'qyyhzh_code': info.qyyhzh_code,
                                'qyyhzh_firm': info.qyyhzh_firm,
                                'qyyhzh_uid': info.yh_id,
                                'qyyhzh_uname': props.yh_name,
                                'qyyhzh_content': props.qyyhzh_content,
                                'qyyhzh_id': props.qyyhzh_id,
                                'qyyhzh_update_uname':props.yh_name,
                                'qyyhzh_qc_amount': info.qyyhzh_qc_amount,
                                'qyyhzh_qc_date': info.qyyhzh_qc_date,
                            }).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功')   
                                    setOpen(false);
                                    form.resetFields();
                                    onCreateEdit(values);
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败：'+res.data.Message)
                                }
                            })
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_fklx_edit_${props.yh_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 5 }}
                    ref={editForm}
                >                    
                        <Form.Item name="qyyhzh_name" wrapperCol={{span:19}} required label='账户简称'>                        
                            <Input onChange={(e) => {
                                setInfo(prevState=>({...prevState,qyyhzh_name:e.target.value}))
                            }}/>
                        </Form.Item>                                           
                        <Form.Item name="qyyhzh_full_name" wrapperCol={{span:19}} required label='账户全称'>                        
                            <Input onChange={(e) => {
                                setInfo(prevState=>({...prevState,qyyhzh_full_name:e.target.value}))
                            }}/>
                        </Form.Item>
                        <Form.Item name="qyyhzh_code" wrapperCol={{span:19}} label='银行账号'>                        
                            <Input onChange={(e) => {
                                setInfo(prevState=>({...prevState,qyyhzh_code:e.target.value}))
                            }}/>
                        </Form.Item>
                        <Form.Item name="qyyhzh_firm" wrapperCol={{span:19}} label='开户银行'>                        
                            <Input onChange={(e) => {
                                setInfo(prevState=>({...prevState,qyyhzh_firm:e.target.value}))
                            }}/>
                        </Form.Item>
                        <Form.Item name="qyyhzh_content" wrapperCol={{span:19}} label='备注'>                        
                            <Input onChange={(e) => {
                                setInfo(prevState=>({...prevState,qyyhzh_content:e.target.value}))
                            }}/>
                        </Form.Item>
                        <Form.Item name="qyyhzh_qc_amount" wrapperCol={{span:12}}  label='期初金额'>                        
                            <InputNumber 
                                placeholder='请输入期初金额'
                                style={{width: '100%'}}
                                min={0.01}
                                max={99999999.99}
                                step={0.01}
                                precision={2}
                                onChange={(value) => {    
                                    setInfo(prevState=>({...prevState,qyyhzh_qc_amount:value}))
                                }}
                            />
                        </Form.Item>
                        <Form.Item name="qyyhzh_qc_date" wrapperCol={{span:12}}  label='期初日期'>                        
                            <DatePicker onChange={(value) => {    
                                setInfo(prevState=>({...prevState,qyyhzh_qc_date:value.format('YYYY-MM-DD')}))
                            }}/>
                        </Form.Item>
                        <Form.Item  wrapperCol={{span:19}} label='新增记录'>                        
                            {props.qyyhzh_ctime} {props.qyyhzh_uname}
                        </Form.Item>
                        <Form.Item   wrapperCol={{span:19}} label='修改记录'>                        
                            {props.qyyhzh_update_time} {props.qyyhzh_update_uname}
                        </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default AccountEdit